import React from "react";
import { View, StyleSheet, TouchableHighlight } from "react-native";
import Swipeable from "react-native-gesture-handler/Swipeable";

import AppText from "../AppText";
import config from "../../config/config";
import ListItemSeperatorReskin from "./ListItemSeperatorReskin";
import Icon from "../Icon";

export default function ListItemReskin({ title, subTitle, subTitle2, IconComponent, onPress, utilityComponent, headerComponent, dropDown = false }) {
    return (
        <View>
            <TouchableHighlight underlayColor={config.colors.secondary} onPress={onPress}>
                <View style={[styles.container, { backgroundColor: dropDown ? config.colors.primary : "#F6F6F6" }]}>
                    {IconComponent && IconComponent}
                    <View style={styles.detailsContainer}>
                        <AppText style={[styles.title, { color: dropDown ? config.colors.white : "#515152" }]} numberOfLines={1}>
                            {title}
                        </AppText>
                        {subTitle && (
                            <AppText style={[styles.subTitle, { color: dropDown ? config.colors.white : "#515152" }]} numberOfLines={3}>
                                {subTitle}
                            </AppText>
                        )}
                        {subTitle2 && (
                            <AppText style={styles.subTitle2} numberOfLines={3}>
                                {subTitle2}
                            </AppText>
                        )}
                        {headerComponent}
                    </View>
                    {utilityComponent}
                </View>
            </TouchableHighlight>
            <ListItemSeperatorReskin />
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        paddingHorizontal: 10,
        paddingVertical: 20,
    },

    detailsContainer: {
        flex: 1,
        marginLeft: 10,
        justifyContent: "center",
    },
    title: {
        fontWeight: "600",
        fontSize: 14,
        color: "#515152",
    },
    subTitle: {
        color: config.colors.medium,
    },
    subTitle2: {
        color: config.colors.medium,
    },
});
